import { useQuery } from 'react-query';
import { getJSON } from '../api/http';
import { endpoints } from '../api/endpoints';

interface IProfileData {
    name: string;
    sipproxy: string;
    lan_network: string;
    services: object;
}

interface wifiElement {
    wifi_essid: string;
    wifi_security: string;
    wifi_password: string;
}

interface services {
    internet: {
        AddressIP: string;
        active: number;
        profile: string;
        speed: string;
    };
    iptv: {
        active: number;
        profile: string;
        speed: string;
    };
    voip: {
        active: number;
        profile: string;
        speed: string;
    };
}

interface ITr069Details {
    id: string;
    serial: string;
    model_name: string;
    mac: string;
    description: string;
    creationdate: string;
    ProfileData: IProfileData;
    ports: object;
    services: services;
    wifi: wifiElement[]
}


export const restructureTr069Details = ({ ProfileData, ports, services, wifi, serial, creationdate, mac, model_name, description, id }: ITr069Details) => ({
    // name: ProfileData.name,
    // sipProxy: ProfileData.sipproxy,
    // lanNetwork: ProfileData.lan_network,
    // availableServices: ProfileData.services,
    profileData: ProfileData,
    serialNumber: serial,
    modelName: model_name,
    creationDate: creationdate,
    macAddress: mac,
    wifi,
    ports,
    services,
    description,
    id,
})


const getTr069Details = async (id: string) =>
    getJSON(endpoints.devices.tr069.details.replaceAll("{id}", id));

export const useTr069Details = (id: string) => {
    const { data, isLoading, error } = useQuery(
        'Tr069Details' + id,
        () => getTr069Details(id),
        {
            staleTime: Infinity,
        }
    );

    return {
        isLoading,
        data: restructureTr069Details(data?.data || {}),
        error,
    };
};
